import React from 'react'
import { NavLink } from 'react-router-dom'

const WebsiteMenu = () => {
    return (
        <>
            <nav className={`navbar navbar-expand-lg navbar-module MenuSticky`}>
                <div className="container-fluid">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#NavbarSecondary"
                        aria-controls="NavbarSecondary"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="NavbarSecondary">
                        <ul className="navbar-nav  m-auto">
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/web-admin/message">Message</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/web-admin/administration">Administration</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/web-admin/voucher-setting">Voucher</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="web-admin/date-sheet-setting">Date Sheet</NavLink>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>

         

        </>
    )
}

export default WebsiteMenu